module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3b0dcb09577ef2049a462686a19110b6.png";